import { useEffect } from "react";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

/**
 * Sets `data-static-ui` on <html> for CSS fallbacks (transitions, will-change).
 */
export const StaticUISync = () => {
  const staticUI = usePreferStaticUI();

  useEffect(() => {
    document.documentElement.toggleAttribute("data-static-ui", staticUI);
    return () => document.documentElement.removeAttribute("data-static-ui");
  }, [staticUI]);

  return null;
};

export default StaticUISync;
